import * as React from 'react';
// import { RvCard } from '../Card';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import { PartyCard, PartyInfoPanel } from './PartyInfoPanel';
import { MatterTerminology } from '../../MatterTerminology';
import { Organisation } from '../../matterDetails/parties/PartiesInfo';
import { PartyCommon, PartyCommonCardProps, PartyPlainField } from './PartyCommon';

export interface OrganizationTableProps extends PartyCommonCardProps {
    data: Organisation;
    tableClassName?: string;
    parentTitle?: string;
}

export class RvOrganizationTable extends React.Component<OrganizationTableProps, {}>  {

    public render() {
        var infoPanelItems = new Array<{}>();

        // Same plain "Label: value" row treatment as addresses/phones/emails below - no
        // bordered-table treatment anywhere in Parties (explicit request).
        if (this.props.data.reference) {
            infoPanelItems.push(<PartyPlainField key="reference" label={MatterTerminology.Reference} value={this.props.data.reference} />);
        }
        if (this.props.data.aBN) {
            infoPanelItems.push(<PartyPlainField key="abn" label={MatterTerminology.ABN} value={this.props.data.aBN} />);
        }
        if (this.props.data.aCN) {
            infoPanelItems.push(<PartyPlainField key="acn" label={MatterTerminology.ACN} value={this.props.data.aCN} />);
        }
        if (this.props.data.organisationType) {
            infoPanelItems.push(<PartyPlainField key="organisationType" label={MatterTerminology.OrganisationType} value={this.props.data.organisationType} />);
        }
        if (this.props.data.businessType) {
            infoPanelItems.push(<PartyPlainField key="businessType" label={MatterTerminology.BusinessType} value={this.props.data.businessType} />);
        }

        PartyCommon.renderCommon(this.props, infoPanelItems, 'inline');

        var showHeader = this.props.parentTitle !== this.props.data.longName;

        return (
            <PartyCard
                icon={<BusinessOutlinedIcon />}
                title={showHeader ? this.props.data.longName : undefined}
                className={this.props.tableClassName}
            >
                <PartyInfoPanel infoItems={infoPanelItems} />
            </PartyCard>
        );
    }
}
